export default "__VITE_ASSET__DFPVSwst__"